module.exports = __webpack_public_path__ + "img/icon-games-black.c2db9bfb.svg";